import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../utils/firebase/firebase.config";
import Compressor from "react-image-file-resizer";

export const uploadMultipleFilesInFirebase = async (
  pathRef,
  data, // Array of objects containing name, file, and metadata
  sendFileData, // Function to return uploaded file data as an array of objects
  setIsUploading, // Boolean state to indicate if uploading is in progress
  setUploadStatus, // Function to set upload status
  nullFileData // Optional function to reset file input
) => {
  // Allowed file types
  const allowedExtensions = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "application/pdf",
  ];

  const uploadedFiles = [];
  setIsUploading(true);
  
  console.log("Actual data", data);

  for (const document of data) {
    const { name } = document;

    // Error handling: File or name validation
    if (!name || !document) {
      setUploadStatus({
        isError: true,
        message: "Document name and file are required.",
      });
      setIsUploading(false);
      throw new Error("Document name and file are required.");
    }

    // Check the file type
    if (!allowedExtensions.includes(document.type)) {
      setUploadStatus({
        isError: true,
        message: `Invalid file type: ${document.type}. Allowed types: PNG, JPEG, JPG, PDF`,
      });
      setIsUploading(false);
      throw new Error(`Invalid file type: ${document.type}`);
    }

    try {
      let fileToUpload = document;

      // Compress images if the file type is an image
      if (document.type.startsWith("image/")) {
        fileToUpload = await new Promise((resolve, reject) => {
          Compressor.imageFileResizer(
            document,
            720, // width
            932, // height
            "WEBP", // compress format WEBP, JPEG, PNG
            65, // quality
            0, // rotation
            (url) => resolve(url),
            "blob", // blob or base64
            (err) => reject(err)
          );
        });
      }

      // Create a storage reference for the file
      const fileName = `${Date.now()}-${document.name}`;
      const storageRef = ref(storage, `${pathRef}/${fileName}`);
      // Set metadata (for correct MIME type)
      const metadata = {
        contentType: document.type,
      };
      const uploadTask = uploadBytesResumable(storageRef, fileToUpload, metadata);

      // Monitor upload progress
      const uploadPromise = new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            // Optional: Track progress if needed
          },
          (error) => {
            setUploadStatus({
              isError: true,
              message: `Error uploading ${document.name}: ${error.message}`,
            });
            reject(error);
          },
          async () => {
            try {
              const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
              uploadedFiles.push({
                name, // Use the custom name provided by the user
                url: downloadURL,
              });
              resolve(downloadURL);
            } catch (err) {
              setUploadStatus({
                isError: true,
                message: `Error getting download URL for ${document.name}: ${err.message}`,
              });
              reject(err);
            }
          }
        );
      });

      await uploadPromise;
    } catch (err) {
      console.error(`Error handling file ${document.name}:`, err);
    }
  }

  // Finalize
  setIsUploading(false);
  if (uploadedFiles.length === data.length) {
    setUploadStatus({
      isError: false,
      message: "All files uploaded successfully!",
    });
    sendFileData(uploadedFiles); // Return array of objects with names and URLs
    if (nullFileData) nullFileData();
  } else {
    setUploadStatus({
      isError: true,
      message: "Some files failed to upload.",
    });
  }
};
